const TEST_ID_CONSTANTS = {
    BOOKING_COUPON: "booking-coupon",
    REVIEW_FORM_QUESTION: "review-form-question",
    REVIEW_FORM_CONTENT_INPUT: "review-form-content-input",
    REVIEW_FORM_IMAGE_INPUT: "review-form-image-input",
    REVIEW_FORM_IMAGE_DESCRIPTION_INPUT: "review-form-image-description-input",
    REVIEW_FORM_RATING_INPUT: "REVIEW_FORM_RATING_INPUT",
    HUBSPOT_FORM_CONTAINER: "hubspot-form-container",
    TRIP_INSURANCE_FORM: "trip-insurance-form",
    PAYMENT_FORM: "payment-form",
}

export default TEST_ID_CONSTANTS
